import {
    AuthenticationMethodTargetType,
    MicrosoftAuthenticatorAuthenticationMode,
} from '@microsoft/microsoft-graph-types-beta';
import { SchemaValue } from '../../../../models/schema';
import { ValidatorFn, AbstractControl, FormArray } from '@angular/forms';

export interface TargetsSchema {
    type: 'array';
    items?: {
        type: 'object';
        oneOf: TargetSchemaItem[];
    };
    minItems?: number;
    maxItems?: number;
}

export interface TargetSchemaItem {
    properties: {
        id: {
            type: 'string';
            const: string;
        };
        isUsableForSignIn?: SchemaValue<boolean, 'boolean'>;

        targetType: {
            type: 'string';
            const: AuthenticationMethodTargetType;
        };

        authenticationMode?: {
            type: 'string';
            const: MicrosoftAuthenticatorAuthenticationMode;
        };
    };
}

export interface IncludeOptionsLookups {
    name: string;
    key: string;
    options: {
        value: string;
        label: string;
    }[];
}

// Custom validator to ensure at least one group is included
export function atLeastOneGroupValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control || !control.parent) {
            return null;
        }

        // Don't validate if state is disabled
        const state = control.parent.get('state')?.value;
        if (state === 'disabled') {
            return null;
        }

        const includedGroups = control.get('includedGroups') as FormArray;

        if (!includedGroups || includedGroups.length === 0) {
            return { noGroupSelected: true };
        }

        return null;
    };
}
